import React, { Component } from 'react';
import HeaderComponent from '../header';
import './index.scss';
import user from './user-3296.svg';
import calender from './calendar.svg';
import copy from './copy.png';
import { toast } from 'react-toastify';
import useAxiosInterceptors from '../config/axios-config';
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

export default class UploadComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            certificateList: [],
            show: false,
            setSelectedFile: null,
            certificateName: '',
            certificatePassword: '',
            showDelete: false,
            selectedCertificate: null,
            stage: null,
            loading: false
        };
    };
    useAxiosLoader(axiosInstance) {
        const [loading] = axiosInstance
    }

    handleClose = () => {
        this.setState({
            show: false,
            selectedCertificate: null
        });
    };

    handleSubmit = (event) => {
        event.preventDefault();
        if (this.state.selectedCertificate != null) {
            this.updateCertificate();
        } else {
            this.addCertificate();
        }

    };

    addCertificate = () => {
        const formData = new FormData();
        formData.append("certificateFile", this.state.selectedFile);
        formData.append("certificateName", this.state.certificateName);
        formData.append("certificatePassword", this.state.certificatePassword);
        try {
            this.setState({
                loading: true
            });
            useAxiosInterceptors.put("/app/cert/v1/upload", formData, {
                headers: {
                    "Content-Type": "multipart/form-data"
                }
            })
                .then((res) => {
                    this.loadData();
                    this.showSuccessToast("Certificate added successfully");
                })
                .catch((err) => {
                    console.log(err);
                })
                .finally(() => {
                    //Hide loader here
                    this.setState({
                        show: false,
                        stage: null,
                        selectedCertificate: null,
                        loading: false
                    });
                })
        } catch (error) {
            console.log(error)
        }
    }

    updateCertificate = () => {
        var data = {
            certificateId: this.state.selectedCertificate.certificateId,
            certificateName: this.state.certificateName
        }
        try {
            this.setState({
                loading: true
            });
            useAxiosInterceptors.post("/app/cert/v1/update", data, {
                headers: {
                    "Content-Type": "application/json"
                }
            })
                .then((res) => {
                    this.loadData();
                    this.showSuccessToast("Certificate updated successfully");
                })
                .catch((err) => {
                    console.log(err);
                })
                .finally(() => {
                    //Hide loader here
                    this.setState({
                        show: false,
                        stage: null,
                        selectedCertificate: null,
                        loading: false
                    });
                })
        } catch (error) {
            console.log(error)
        }
    }

    handleFileSelect = (event) => {
        this.setState({ selectedFile: event.target.files[0] });
    }

    certFileNameChange = (event) => {
        this.setState({ certificateName: event.target.value });
    }

    certFilePasswordChange = (event) => {
        this.setState({ certificatePassword: event.target.value });
    }

    handleShow = () => {
        this.setState({
            show: true,
            stage: "new"
        });
    };

    handleUpdateShow = (d) => {
        this.setState({
            show: true,
            stage: "update",
            selectedCertificate: d
        });
        this.setState({ stage: "update" });
    };

    handleDelete = (d) => {
        this.setState({ selectedCertificate: d });
        this.setState({ showDelete: true });
    }

    hideDeletePopUp = () => {
        this.setState({ selectedCertificate: null });
        this.setState({ showDelete: false });
    }

    handleDeleteConfirm = () => {
        this.setState({
            loading: true
        });
        useAxiosInterceptors.delete(`/app/cert/v1/delete?certificateId=${this.state.selectedCertificate.certificateId}`, {
            headers: {
                "Content-Type": "application/json"
            }
        })
            .then((res) => {
                this.loadData();
                this.state.selectedCertificate = null;
                this.showSuccessToast("Certificate removed successfully");
            })
            .catch((err) => {
                console.log(err);
            })
            .finally(() => {
                //Hide loader here
                this.setState({
                    show: false,
                    stage: null,
                    selectedCertificate: null,
                    loading: false
                });
            })
        this.setState({ showDelete: false });
    }

    componentDidMount() {
        this.loadData();
    }

    loadData = () => {
        this.setState({
            loading: true
        });
        useAxiosInterceptors.get("/app/cert/v1/all", {
            headers: {
                "Content-Type": "application/json"
            }
        })
            .then((res) => {
                this.state.certificateList = res.data;
            })
            .catch((err) => {
                console.log(err);
            })
            .finally(() => {
                //Hide loader here
                this.setState({
                    show: false,
                    stage: null,
                    selectedCertificate: null,
                    loading: false
                });
            });
    }

    showSuccessToast = (message) => {
        toast.info(message, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: 0,
            type: "success"
        });
    }

    render() {
        const { certificateList } = this.state;
        const { selectedCertificate } = this.state;
        const { stage } = this.state;
        const { loading } = this.state;

        return (
            <div>
                <HeaderComponent />
                <>
                    {loading ?
                        <>
                            <div className="overlay">
                                <div className="overlay__inner">
                                    <div className="overlay__content">
                                        <span className="spinner"></span>
                                    </div>
                                </div>
                            </div>
                        </>
                        :
                        <>
                            {this.state.show}
                            <div className="container mt-5">
                                <div className="row mb-4">
                                    <div className="col-lg-6">
                                        <h3 className='mb-3'>Uploaded Certificates</h3>
                                    </div>
                                    <div className="col-lg-6 text-right">
                                        <button className='btn btn-primary' onClick={this.handleShow}>Configure new certificate</button>
                                    </div>
                                    {certificateList.map(d => (
                                        <div className="col-lg-6">
                                            <div className="card p-4">
                                                <div className="row">
                                                    <div className="col-lg-12">
                                                        <span className=' badge bg-custom cert-name copy-button' onClick={() => { navigator.clipboard.writeText(d.signatureId) }}>
                                                            {d.certificateId} &nbsp;
                                                            <img className='action-icons' src={copy}></img>
                                                        </span>
                                                    </div>
                                                    <div className="col-lg-12 mt-3">
                                                        <p className='cert-name'>{d.certificateName}</p>
                                                    </div>
                                                    <div className="col-lg-12 uploaded-by">
                                                        <p>
                                                            <img src={user} style={{ height: "20px", width: "30px" }}></img>
                                                            {d.uploadedBy}
                                                        </p>
                                                    </div>
                                                    <div className="col-lg-12">
                                                        <p>
                                                            <img src={calender} style={{ height: "20px", width: "30px" }}></img>
                                                            {d.createdOn}
                                                        </p>
                                                    </div>
                                                    <div className="col-lg-12">
                                                        <div className="btn btn-sm btn-outline-primary" onClick={() => this.handleUpdateShow(d)}>Edit</div>
                                                        <div className="mx-2 btn btn-sm btn-outline-danger" onClick={() => this.handleDelete(d)}>Delete</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                            <Modal
                                size="md"
                                show={this.state.showDelete}
                                aria-labelledby="example-modal-sizes-title-sm"
                            >
                                <Modal.Header closeButton>
                                    <Modal.Title id="example-modal-sizes-title-sm">
                                        Confirm
                                    </Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    <h5>Are you sure you want to delete this certificate?
                                        {selectedCertificate != null && selectedCertificate.certificateId}
                                    </h5>
                                </Modal.Body>
                                <Modal.Footer>
                                    <Button variant="secondary" onClick={this.hideDeletePopUp}>
                                        Cancel
                                    </Button>
                                    <Button variant="danger" onClick={this.handleDeleteConfirm}>
                                        Confirm
                                    </Button>
                                </Modal.Footer>
                            </Modal>
                            <Modal show={this.state.show} onHide={this.handleClose}>
                                <Modal.Header closeButton>
                                    <Modal.Title>Upload your certificate</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    <Form>
                                        <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                            <Form.Label>Certificate Name</Form.Label>
                                            <Form.Control
                                                type="text"
                                                defaultValue={this.state.selectedCertificate != null ? this.state.selectedCertificate.certificateName : ''}
                                                onChange={this.certFileNameChange}
                                                placeholder="Enter Certificate Name"
                                                autoFocus
                                            />
                                        </Form.Group>
                                        {stage == 'new' &&
                                            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                                <Form.Label>Certificate Password</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    defaultValue={this.state.selectedCertificate != null ? this.state.selectedCertificate.certificatePassword : ''}
                                                    onChange={this.certFilePasswordChange}
                                                    placeholder="Enter Certificate Password"
                                                />
                                            </Form.Group>}
                                        {stage == 'new' &&
                                            <Form.Group
                                                className="mb-3"
                                                controlId="exampleForm.ControlTextarea1"
                                            >
                                                <Form.Label>Choose File</Form.Label>
                                                <Form.Control type='file' onChange={this.handleFileSelect} />
                                            </Form.Group>
                                        }

                                    </Form>
                                </Modal.Body>
                                <Modal.Footer>
                                    <Button variant="secondary" onClick={this.handleClose}>
                                        Close
                                    </Button>
                                    <Button variant="primary" onClick={this.handleSubmit}>
                                        Save Changes
                                    </Button>
                                </Modal.Footer>
                            </Modal>
                        </>
                    }
                </>
            </div>
        );
    };

}

// export default UploadComponent;
